"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHandler = void 0;
var tslib_1 = require("tslib");
var AuthHandler = (function () {
    function AuthHandler() {
    }
    AuthHandler.setAuthConfiguration = function (authConfiguration) {
        this.getAccessTokenFunction = authConfiguration.getAccessToken;
    };
    AuthHandler.getAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accessToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof this.getAccessTokenFunction === 'function')) return [3, 2];
                        return [4, this.getAccessTokenFunction()];
                    case 1:
                        accessToken = _a.sent();
                        return [2, accessToken];
                    case 2: return [2, undefined];
                }
            });
        });
    };
    return AuthHandler;
}());
exports.AuthHandler = AuthHandler;
//# sourceMappingURL=auth-handler.js.map